export default __webpack_public_path__ + "012cf6a10129e2275d79d6adac7f3b02.woff";